import { TimeStandardSettings } from 'apps/studio/components/settings/fields/Time/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const TimeSettings = [
  FieldSettingsPanel(TimeStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
